import useBriefContext from '../../../../Hooks/Brief/useBriefContext/useBriefContext'
import { Currency } from '../../../../Types/generated-types'
import BudgetCaption from '../BudgetCaption'

interface BizBudgetOptionsInput {
  budget: number | ''
  currency?: Currency
}

const BizBudgetOptions = ({ budget, currency }: BizBudgetOptionsInput): JSX.Element => {
  const { brief } = useBriefContext()
  return (
    <BudgetCaption
      budget={budget || undefined}
      currencySymbol={currency?.symbol}
      numGuests={brief.capacities ?? 1}
    />
  )
}

export default BizBudgetOptions
